import React, { useRef } from "react";
import styled from "styled-components";

const ACCENT = "#3f88a5";

const Wrapper = styled.div`
  position: relative;
  background: #fff;
  border-radius: 10px;
  border: 0.5px solid rgba(0, 0, 0, 0.1);
  padding: 6px;
  margin-bottom: 24px;

  &::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 56px;
    border-radius: 0 10px 10px 0;
    background: linear-gradient(to right, transparent, #fff);
    pointer-events: none;
    z-index: 1;
  }
`;

const Strip = styled.div`
  display: flex;
  gap: 3px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-bottom: 1px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const Tab = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 13px;
  border-radius: 7px;
  border: none;
  background: ${({ $active }) => ($active ? ACCENT : "transparent")};
  color: ${({ $active }) => ($active ? "#fff" : "#6b7280")};
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;
  outline: none;

  &:hover {
    background: ${({ $active }) => ($active ? ACCENT : "#f3f4f6")};
    color: ${({ $active }) => ($active ? "#fff" : "#111827")};
  }

  i {
    font-size: 14px;
    line-height: 1;
  }
`;

/**
 * SettingsTabNav
 *
 * @param {Array}    tabs         — [{ key, label, icon? }]  icon = tabler icon name e.g. "user"
 * @param {string}   activeKey    — currently active tab key
 * @param {Function} onChange     — (key) => void
 */
const NavigationTabs = ({ tabs = [], activeKey, onChange }) => {
  const activeRef = useRef(null);

  const handleClick = (key, el) => {
    onChange(key);
    // Scroll active tab into view with some padding
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }
  };

  return (
    <Wrapper>
      <Strip role="tablist">
        {tabs.map((tab) => (
          <Tab
            key={tab.key}
            role="tab"
            aria-selected={activeKey === tab.key}
            $active={activeKey === tab.key}
            onClick={(e) => handleClick(tab.key, e.currentTarget)}
          >
            {tab.icon && <i className={`fas fa-${tab.icon}`} aria-hidden="true" />}
            {tab.label}
          </Tab>
        ))}
      </Strip>
    </Wrapper>
  );
};

export default NavigationTabs;